<template>
  <dialog-reset
    height="75vh"
    top="8vh"
    width="75%"
    title="选择关联设备"
    DialogClass="select-device-dialog-reset"
    :visible.sync="visible"
    :zoomShow="false"
  >
    <avue-crud
      v-if="visible"
      ref="crud"
      class="select-device-crud"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @row-dblclick="handleSelect"
      @on-load="onLoad"
    >
    </avue-crud>
    <span slot="dialog_footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </dialog-reset>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getDeviceList } from "../api";
import DialogReset from "@/basic-common/components/DialogReset.vue";

export default {
  name: "SelectDeviceDialog",
  components: {
    DialogReset
  },
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList: getDeviceList },
      visible: false,
      selectedRow: null,
      option: {
        cancelHijack: true,
        height: "calc(75vh - 200px)",
        tip: false,
        border: true,
        index: true,
        indexLabel: "序号",
        addBtn: false,
        menu: false,
        searchShow: true,
        searchSpan: 6,
        searchMenuSpan: 24,
        searchMenuPosition: "right",
        searchLabelWidth: 80,
        align: "center",
        highlightCurrentRow: true,
        column: [
          {
            label: "设备名称",
            prop: "deviceName",
            search: true,
            minWidth: 180,
            overHidden: true
          },
          {
            label: "设备类型",
            prop: "deviceType",
            type: "select",
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=base_device_type",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            dataType: "string",
            minWidth: 120
          },
          {
            label: "设备型号",
            prop: "deviceModel",
            minWidth: 120
          },
          {
            label: "设备分类",
            prop: "category",
            type: "select",
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=category",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            dataType: "string",
            minWidth: 120
          },
          {
            label: "运行状态",
            prop: "operationStatus",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=device_status",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            dataType: "string",
            minWidth: 100
          },
          {
            label: "设备位置",
            prop: "location",
            minWidth: 150,
            overHidden: true
          }
        ]
      }
    };
  },
  methods: {
    open() {
      this.resetDialogState();
      this.visible = true;
    },

    resetDialogState() {
      this.selectedRow = null;
      this.query = {};
      this.queryData = {};
      this.defaults = {};
      this.data = [];
      this.page = {
        pageSize: this.page && this.page.pageSize ? this.page.pageSize : 10,
        currentPage: 1,
        total: 0
      };
    },

    handleSelect(row) {
      this.$emit("select", row);
      this.visible = false;
    },

    handleConfirm() {
      if (!this.selectedRow) {
        this.$message.warning("请选择一个设备");
        return;
      }
      this.$emit("select", this.selectedRow);
      this.visible = false;
    },

    // 重写currentChange方法，记录选中行
    currentChange(currentRow) {
      this.selectedRow = currentRow;
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .select-device-dialog-reset .el-dialog__body {
  box-sizing: border-box;
  padding: 42px 36px 62px;
  overflow: hidden;
}

::v-deep .select-device-crud {
  width: 100%;

  .el-card__body {
    padding: 0;
  }

  .avue-crud__search {
    margin-bottom: 12px;
  }

  .avue-crud__search .el-card__body {
    padding: 10px 14px;
  }

  .avue-crud__table,
  .el-table {
    width: 100%;
  }

  .avue-crud__table {
    margin-top: 0;
  }

  .avue-crud__pagination {
    margin-top: 10px;
  }
}

::v-deep .avue-crud__menu {
  display: none;
}
</style>
